import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NzMessageService } from "ng-zorro-antd/message";
import { HttpCommunicationService } from "../../../service/http-communication.service";
import { HttpAnalyticsService } from "../../../service/http-analytics.service";
import { catchError } from "rxjs";
import { DashboardDto, DashboardRequestDto } from "../../../service/dto";
import { NzTableQueryParams } from "ng-zorro-antd/table";
import { embedDashboard } from '@superset-ui/embedded-sdk'
import { faEye } from "@fortawesome/free-solid-svg-icons";

@Component({
	selector: 'app-analytics-list',
	standalone: false,
	templateUrl: './analytics-list.component.html',
	styleUrls: ['./analytics-list.component.scss'],
})
export class AnalyticsListComponent implements OnInit {

	dashboards!: DashboardDto[];
	loading = false;
	total = 0;
	pageSize = 10;
	pageIndex = 1;

	faEye = faEye;

	isModalVisible = false;
    selectedDashboard: DashboardDto | null = null;
    @ViewChild('modalDashboardContainer') modalDashboardContainer!: ElementRef;

	constructor(
		private message: NzMessageService,
		private router: Router,
		private httpService: HttpAnalyticsService) {}

	ngOnInit(): void {
		this.fetchDashboards();
	}

	openViewModal(item: DashboardDto) {
        // 1. Check if the item actually has the embedded ID (UUID)
        if (!item.dashboardEmbeddedId) {
            this.message.error("This dashboard is not configured for embedding (No UUID)");
            return;
        }

        this.selectedDashboard = item;
        this.isModalVisible = true;

        // 2. Wait for the modal DOM to render before calling the SDK
        // We need a short timeout because *nzModalContent lazy loads the DOM
        setTimeout(() => {
            this.embedSupersetDashboard(item);
        }, 200);
    }

    handleModalCancel() {
        this.isModalVisible = false;
        this.selectedDashboard = null;
        // The iframe is destroyed automatically when the modal content is removed from DOM
    }

	private async embedSupersetDashboard(item: DashboardDto) {
        if (!this.modalDashboardContainer?.nativeElement) {
            console.error("Dashboard container not found in modal");
            return;
        }

        // Clear previous content (like the spinner)
        this.modalDashboardContainer.nativeElement.innerHTML = "";

		var payload: DashboardRequestDto = {
			dashboardEmbeddedId: item.dashboardEmbeddedId
		}
		console.log('item:', item);
		console.log('payload:', payload);
        try {
            await embedDashboard({
                id: item.dashboardEmbeddedId, // Ensure your DTO has this field
                supersetDomain: "https://superset.pandadigital.co.za",
                mountPoint: this.modalDashboardContainer.nativeElement,
                fetchGuestToken: () => new Promise((resolve, reject) => 
					this.httpService.fetchGuestToken(payload).subscribe({
						next: (res) => resolve(res.guestToken), // Extract the string string
						error: (err) => reject(err)             // Handle HTTP errors
					})
				),
                dashboardUiConfig: { 
                    hideTitle: true, 
                    filters: { expanded: false } // Collapsed filters usually look better in modals
                },
                iframeSandboxExtras: ['allow-top-navigation', 'allow-popups-to-escape-sandbox'],
                referrerPolicy: "no-referrer-when-downgrade",
            });

            // Styling the iframe
            const iframe = this.modalDashboardContainer.nativeElement.querySelector('iframe');
            if (iframe) {
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                iframe.style.border = 'none';
            }

        } catch (e) {
            console.error('Error embedding dashboard:', e);
            this.message.error("Could not load dashboard");
        }
    }

	private fetchDashboards() {
		this.loading = true;
		this.httpService.getActiveDashboards(this.pageIndex, this.pageSize)
		.pipe(
			catchError(error => {
				console.log('Error fetching active dashboards', error);
				this.message.error('Failed to fetch active dashboards');
				throw error;
			})
		)
		.subscribe({
			next: (res) => {
				this.loading = false;
				this.dashboards = res.list;
				this.total = res.totalItems;
				this.pageIndex = res.pageIndex;
				this.pageSize = res.pageSize;
			},
			error: () => {
				this.loading = false;
			},
		});
	}

	getThis(): AnalyticsListComponent {
		return this;
	}

	onQueryParamsChange(params: NzTableQueryParams, that: AnalyticsListComponent): void {
		const { pageIndex, pageSize } = params;
		if (pageIndex == that.pageIndex && pageSize == that.pageSize) {
			return;
		}
		that.pageIndex = pageIndex;
		that.pageSize = pageSize;

		this.fetchDashboards();
	}

    toggleFavourite(input: DashboardDto) {
		if (input.favourite) {
			this.message.warning("At least one dashboard must be set as the homepage");
			return;
		}

		const wasFavourite = input.favourite;

		this.dashboards.forEach(d => d.favourite = false);

		if (!wasFavourite) {
			input.favourite = true;
		}

		this.httpService.setFavourite(input.id)
		.pipe(
			catchError(error => {
				this.fetchDashboards();
				console.log('Error toggling favourite', error);
				this.message.error('Failed to update favourite status');
				throw error;
			})
		)
		.subscribe({
			next: (res) => {
				if (input.favourite) {
					this.message.success(`Dashboard '${input.dashboardTitle}' set as homepage`);
				} else {
					this.message.success(`Dashboard '${input.dashboardTitle}' removed from homepage`);
				}
			}
		});
	}

}